export const GET_COST_TYPES = "GET_COST_TYPES";
export const GET_COST_TYPE = "GET_COST_TYPE";
export const ADD_COST_TYPE = "ADD_COST_TYPE";
export const DELETE_COST_TYPE = "DELETE_COST_TYPE";
export const UPDATE_COST_TYPE = "UPDATE_COST_TYPE";
